export default __webpack_public_path__ + "static/media/Social_login.4fe48ded.svg";